import React, {useEffect, useState} from "react";
import "./style.scss";

import TradingActivity from "../../../components/AccountMetrics/TradingActivity";
import {useSelector} from "react-redux";
import ErrorModal from "../../../reusableComponents/ErrorModal";
import BarCharts from "./BarChart/BarCharts";
import LoaderOverlay from "../../../reusableComponents/Loader";

function TradingJournal() {
  const accountsData = useSelector((state) => state?.account?.accountMetrics);
  const [errorModalOpen, setErrorModalOpen] = useState(accountsData.error);

  useEffect(() => {
    setErrorModalOpen(accountsData.error);
  }, [accountsData]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {errorModalOpen && (
        <ErrorModal
          desc={accountsData.message}
          setModalOpen={setErrorModalOpen}
          btnText="Cancel"
        />
      )}

      {!accountsData.loading && !accountsData.error ? "" : <LoaderOverlay />}
      <TradingActivity isTradelocker={accountsData?.data?.trading_platform} />
    </>
  );
}

export default TradingJournal;
